import { useCallback, useEffect, useMemo, useState } from "react";
import {
  fetchPublicSitePricingSettings,
  savePublicSitePricingSettings,
} from "../../services/publicSitePricingSettingsApi";
import { mapPublicSitePricingSettingsFromApi } from "../../utils/agentPublicSitePricingSettingsMapper";

export function useAgentPublicSitePricingSettings() {
  const [settings, setSettings] = useState({
    hotel: { type: "fixed", value: 0 },
    flight: { type: "fixed", value: 0 },
    vacation_package: { type: "fixed", value: 0 },
  });
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    setLoading(true);
    setStatus("loading");
    setError(null);
    try {
      const data = await fetchPublicSitePricingSettings();
      const mapped = mapPublicSitePricingSettingsFromApi(data);
      setSettings(mapped);
      setStatus("ready");
      return data;
    } catch (err) {
      setStatus("error");
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const save = useCallback(async (payload) => {
    setLoading(true);
    setError(null);
    try {
      await savePublicSitePricingSettings(payload);
      const data = await fetchPublicSitePricingSettings();
      const mapped = mapPublicSitePricingSettingsFromApi(data);
      setSettings(mapped);
      setStatus("ready");
      return data;
    } catch (err) {
      setStatus("error");
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh().catch(() => {});
  }, [refresh]);

  return useMemo(
    () => ({
      publicSiteFixedHotelCommission:
        Number(settings?.hotel?.value) || 0,
      publicSiteFixedFlightCommission:
        Number(settings?.flight?.value) || 0,
      publicSiteVacationPackageCommission:
        Number(settings?.vacation_package?.value) || 0,
      publicSitePricingByCategory: settings,
      status,
      error,
      loading,
      refresh,
      save,
    }),
    [settings, status, error, loading, refresh, save]
  );
}
